import { render, staticRenderFns } from "./ProjectReportDetail.vue?vue&type=template&id=65f5ac78"
import script from "./ProjectReportDetail.vue?vue&type=script&lang=js"
export * from "./ProjectReportDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports